/**
 * @generated SignedSource<<2e618f18080237b683c34cf2e4ad11f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DevMenuSmartTrackerProcessingMutation$variables = {
  eventGuid: string;
  smartTrackerIds: ReadonlyArray<string>;
};
export type DevMenuSmartTrackerProcessingMutation$data = {
  readonly devMenuProcessSmartTrackers: {
    readonly ok: boolean;
  } | null;
};
export type DevMenuSmartTrackerProcessingMutation = {
  response: DevMenuSmartTrackerProcessingMutation$data;
  variables: DevMenuSmartTrackerProcessingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventGuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "smartTrackerIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "eventGuid",
        "variableName": "eventGuid"
      },
      {
        "kind": "Variable",
        "name": "smartTrackerIds",
        "variableName": "smartTrackerIds"
      }
    ],
    "concreteType": "DevMenuProcessSmartTrackers",
    "kind": "LinkedField",
    "name": "devMenuProcessSmartTrackers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DevMenuSmartTrackerProcessingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DevMenuSmartTrackerProcessingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c8df62a963e41380c4ebd658ad2ec864",
    "id": null,
    "metadata": {},
    "name": "DevMenuSmartTrackerProcessingMutation",
    "operationKind": "mutation",
    "text": "mutation DevMenuSmartTrackerProcessingMutation(\n  $eventGuid: String!\n  $smartTrackerIds: [ID!]!\n) {\n  devMenuProcessSmartTrackers(eventGuid: $eventGuid, smartTrackerIds: $smartTrackerIds) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9c0b588790ef54413300c78c73e0abb";

export default node;
